import { render } from "./UserList.vue?vue&type=template&id=07ef83f2&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./UserList.vue?vue&type=style&index=0&id=07ef83f2&lang=scss&module=true"
cssModules["$style"] = style0
import "./UserList.vue?vue&type=style&index=1&id=07ef83f2&lang=scss&scoped=true"

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-07ef83f2"]])

export default __exports__